var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-nav',{staticClass:"auth-navbar fixed-top",attrs:{"type":"white","transparent":true,"menu-classes":"justify-content-end"},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('div',{staticClass:"navbar-wrapper",attrs:{"slot":"brand"},slot:"brand"})])
}
var staticRenderFns = []

export { render, staticRenderFns }